import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Market from "@/pages/market/page";
import GoldHistory from "@/pages/gold-history/page";
import Trading from "@/pages/trading/page";
import Assets from "@/pages/assets/page";
import Login from "@/pages/login/page";
import Profile from "@/pages/profile/page";
import Kyc from "@/pages/kyc/page";
import Bank from "@/pages/bank/page";
import Notifications from "@/pages/notifications/page";
import Support from "@/pages/support/page";
import CheckRequest from "@/pages/check-request/page";
import Dashboard from "@/pages/dashboard/page";
import Deposit from "@/pages/deposit/page";
import Withdraw from "@/pages/withdraw/page";
import AdminUsers from "@/pages/admin/users/page";
import AdminDeposits from "@/pages/admin/deposits/page";
import AdminOrders from "@/pages/admin/orders/page";
import AdminBanners from "@/pages/admin/banners/page";
import AdminLogs from "@/pages/admin/logs/page";
import AdminSupport from "@/pages/admin/support/page";
import AdminMaintenance from "@/pages/admin/maintenance/page";
import AdminGoldPrices from "@/pages/admin/gold-prices/page";
import RequireAuth from "@/components/feature/RequireAuth";
import RequireAdmin from "@/components/feature/RequireAdmin";
import LiveChat from "@/pages/live-chat/page";
import LiveChatStandalone from "@/pages/live-chat-standalone/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/thi-truong", element: <RequireAuth><Market /></RequireAuth> },
  { path: "/lich-su-gia-vang", element: <GoldHistory /> },
  { path: "/giao-dich", element: <RequireAuth><Trading /></RequireAuth> },
  { path: "/tai-san", element: <RequireAuth><Assets /></RequireAuth> },
  { path: "/dang-nhap", element: <Login /> },
  { path: "/ho-so", element: <RequireAuth><Profile /></RequireAuth> },
  { path: "/xac-minh-danh-tinh", element: <RequireAuth><Kyc /></RequireAuth> },
  { path: "/ngan-hang", element: <RequireAuth><Bank /></RequireAuth> },
  { path: "/thong-bao", element: <RequireAuth><Notifications /></RequireAuth> },
  { path: "/lien-he", element: <Support /> },
  { path: "/kiem-tra-yeu-cau", element: <CheckRequest /> },
  { path: "/bang-dieu-khien", element: <RequireAuth><Dashboard /></RequireAuth> },
  { path: "/nap-tien", element: <RequireAuth><Deposit /></RequireAuth> },
  { path: "/rut-tien", element: <RequireAuth><Withdraw /></RequireAuth> },
  { path: "/chat-ho-tro", element: <RequireAuth><LiveChat /></RequireAuth> },
  { path: "/live-chat", element: <RequireAuth><LiveChatStandalone /></RequireAuth> },
  { path: "/quan-tri/nguoi-dung", element: <RequireAdmin><AdminUsers /></RequireAdmin> },
  { path: "/quan-tri/nap-rut", element: <RequireAdmin><AdminDeposits /></RequireAdmin> },
  { path: "/quan-tri/lenh-giao-dich", element: <RequireAdmin><AdminOrders /></RequireAdmin> },
  { path: "/quan-tri/banner-tin-tuc", element: <RequireAdmin><AdminBanners /></RequireAdmin> },
  { path: "/quan-tri/nhat-ky", element: <RequireAdmin><AdminLogs /></RequireAdmin> },
  { path: "/quan-tri/tin-nhan-ho-tro", element: <RequireAdmin><AdminSupport /></RequireAdmin> },
  { path: "/quan-tri/bao-tri", element: <RequireAdmin><AdminMaintenance /></RequireAdmin> },
  { path: "/quan-tri/gia-vang", element: <RequireAdmin><AdminGoldPrices /></RequireAdmin> },
  { path: "*", element: <NotFound /> },
];

export default routes;